import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MeasurementItem from './MeasurementItem';
import { useTheme } from '../../contextProviders';
import classNames from 'classnames';

const MeasurementTable = ({
  data = [],
  title,
  onClick = () => {},
  onEdit = () => {},
  onDelete,
  servicesManager,
}: withAppTypes) => {
  const { isDarkMode } = useTheme();
  const { customizationService, measurementService } = servicesManager.services;
  const { t } = useTranslation('MeasurementTable');
  const amount = data.length;

  const itemCustomization = customizationService.getCustomization('MeasurementItem', {
    content: MeasurementItem,
    contentProps: {},
  });
  const CustomMeasurementItem = itemCustomization.content;

  const onMeasurementDeleteHandler = ({ uid }) => {
    const measurement = measurementService.getMeasurement(uid);
    onDelete?.({ uid });
    measurementService.remove(
      uid,
      {
        ...measurement,
      },
      true
    );
  };

  return (
    <div>
      <div className={`${isDarkMode ? "!bg-secondary-main !text-white" : "!bg-customLightColor-level3 !text-black"} flex justify-between px-2 py-1`}>
        <span className="text-base font-bold uppercase tracking-widest" style={{ color: isDarkMode ? "white" : "black" }}>{t(title)}</span>
        <span className="text-base font-bold" style={{ color: isDarkMode ? "white" : "black" }}>{amount}</span>
      </div>
      <div className="ohif-scrollbar max-h-112 overflow-hidden">
        {data.length !== 0 &&
          data.map((measurementItem, index) => (
            <CustomMeasurementItem
              key={measurementItem.uid}
              uid={measurementItem.uid}
              index={index + 1}
              label={measurementItem.label}
              isActive={measurementItem.isActive}
              displayText={measurementItem.displayText}
              item={measurementItem}
              onClick={onClick}
              onEdit={onEdit}
              onDelete={onMeasurementDeleteHandler}
            />
          ))}
        {data.length === 0 && (
          <div className={classNames("group flex cursor-default border border-transparen transition duration-300", isDarkMode ? "!bg-black" : "!bg-white")}>
            <div className={`${isDarkMode ? "!bg-primary-dark !group-hover:bg-secondary-main" : "!bg-customLightColor-level3 !group-hover:bg-customLightColor-level4"} text-primary-light w-6 py-1 text-center text-base transition duration-300`}></div>
            <div className="flex flex-1 items-center justify-between px-2 py-4">
              <span className={`${!isDarkMode ? "!text-black" : "!text-primary-light"} mb-1 flex flex-1 items-center text-base`}>
                {t('No tracked measurements')}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

MeasurementTable.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      displayText: PropTypes.arrayOf(PropTypes.string),
      isActive: PropTypes.bool,
    })
  ),
  onClick: PropTypes.func,
  onEdit: PropTypes.func,
};

export default MeasurementTable;
